;(typeof module.exports === "function" ? module.exports.options : module.exports).template = require("-!vue-html-loader!./../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./article.vue")
if (module.hot) {
(function () {
var hotAPI = require("vue-hot-reload-api")
hotAPI.install(require("vue"))
if (!hotAPI.compatible) return
var id = "-!vue-html-loader!./../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./article.vue"
hotAPI.createRecord(id, module.exports)
module.hot.accept(["-!vue-html-loader!./../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./article.vue"], function () {
var newOptions = null
if (newOptions && newOptions.__esModule) newOptions = newOptions.default
var newTemplate = require("-!vue-html-loader!./../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./article.vue")
hotAPI.update(id, newOptions, newTemplate)
})
})()
}


/*****************
 ** WEBPACK FOOTER
 ** ./components/article/article.vue
 ** module id = 112
 ** module chunks = 0
 **/